
import { Component, Vue } from 'vue-property-decorator'

import BacLoggedInHeader from '@/templates/BacLoggedInHeader.vue'
import BacButton from '@/components/BacButton.vue'
import BacModal from '@/components/BacModal.vue'
import BacInput from '@/components/BacInput.vue'

import { Voting } from '../../lib/models/Voting'
import { VotingAnswer } from '../../lib/models/VotingAnswer'

@Component({
  components: {
    BacLoggedInHeader,
    BacButton,
    BacModal,
    BacInput
  }
})
export default class Votings extends Vue {
  headers = [
    { text: 'ID', value: 'id', width: 30 },
    { text: 'Name', value: 'name', width: 80 },
    { text: 'Bearbeiten', value: 'edit', width: 80 },
    { text: 'Link', value: 'link', width: 80 },
    { text: 'Erstellt am', value: 'createdAt', width: 15 },
    { text: 'Löschen', value: 'delete', width: 15 }
  ]

  votings: Voting[] = []

  editVotingId = -1
  get editedVoting () {
    return this.votings.find(voting => voting.id === this.editVotingId) ?? new Voting()
  }

  createVoting = new Voting()

  get items () {
    return this.votings.map((voting: Voting) => {
      return {
        id: voting.id,
        name: voting.name,
        createdAt: voting.createdAt
      }
    })
  }

  getLinkToVote (voteId: number) {
    return `${window.location.protocol}//${window.location.host}/teamarea/vote.php?vote=${voteId}`
  }

  mounted () {
    this.loadVotings()
  }

  async loadVotings () {
    this.votings = await Voting.getAll({})
  }

  async saveEditVoting () {
    await this.editedVoting.update()
    await this.loadVotings()
  }

  editAddNewAnswer () {
    this.editedVoting.answers.push(new VotingAnswer())
  }

  createAddNewAnswer () {
    this.createVoting.answers.push(new VotingAnswer())
  }

  async deleteEditVoting () {
    await Voting.delete(this.editVotingId)
    await this.loadVotings()
  }

  async saveCreateVoting () {
    await this.createVoting.create()
    await this.loadVotings()
  }
}

